import React from 'react';

export const DesktopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="37" fill="none" viewBox="0 0 40 37">
    <path
      fill="#427783"
      d="M38.008.492H1.992c-.547 0-1.015.196-1.406.586-.39.39-.586.86-.586 1.406v24.024c0 .547.195 1.015.586 1.406.39.39.86.586 1.406.586h16.016v3.984H10v4.024h20v-4.024h-8.008V28.5h16.016c.547 0 1.015-.195 1.406-.586.39-.39.586-.86.586-1.406V2.484c0-.546-.195-1.015-.586-1.406-.39-.39-.86-.586-1.406-.586zm-1.992 24.024H3.984v-20h32.032v20zM8.086 8.578h16.367v3.985H8.086V8.578zm0 8.008h10v3.984h-10v-3.984z"
    />
  </svg>
);
